import styled from "styled-components";
import { Atom } from 'AppReact';

const template = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  left: -48px;
  top: 70px;
  width: 48px;
  height: 48px;
  cursor: pointer;

  background-color: #F4FCF8;

  @media (min-width: 1560px) {
    display: none;
  }
`;

export default Atom({ type: 'button', dataType: 'object', template })